import { action, extendObservable, toJS } from 'mobx';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import FileRepositoryTreeService from './FileRepositoryTreeService';

class FileRepositoryCategoryService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      attachmentRepositories: [],
    });
    this.form.validations = {
      title: [isRequired],
    };
  }

  init = action(() => {});

  handleRemove = action(({ item }) => {
    ConfirmationDialogService.show(
      'Delete Category',
      `You are sure to delete the category "${item.title}"? All categories and files below on hierarchy is gonna be deleted too.`,
      () => {
        this.fetch
          .fetch({
            url: `/attachment-repositories/${item.id}`,
            apiVersion: 'v3',
            method: 'delete',
          })
          .then(() => {
            NotificationService.addNotification(`Category "${item.title}" deleted successfully.`, 'success');
            FileRepositoryTreeService.load();
          });
      }
    );
  });

  handleSetIsEditing = action((data) => {
    this.isEditing = true;
    this.form.setValues({ ...data });
    this.isModalOpen = true;
  });

  handleResetCategoryModal = () => {
    const parentId = this.form.getValue('parent');
    if (this.isEditing) {
      const id = this.form.getValue('id');
      this.form.reset();
      this.form.setValue('id', id);
    } else {
      this.form.reset();
    }
    this.form.setValue('parent', parentId);
  };

  handleToggleCategoryModal = (parentId) => {
    this.form.reset();
    this.isModalOpen = !this.isModalOpen;
    this.isEditing = false;
    this.form.setValue('parent', parentId);
  };

  handleCategorySubmit = action(() => {
    this.form.setSubmitted();
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const { id, parent, title, description } = toJS(this.form.getValues());
    const iconFile = this.form.getValue('iconFile');

    const formData = new FormData();
    if (title) {
      formData.append('title', title);
    }
    if (description) {
      formData.append('description', description);
    }
    if (iconFile) {
      formData.append('iconFile', iconFile);
    }
    if (!this.isEditing) {
      if (parent) {
        formData.append('parent', parent);
      }
    }

    this.fetch
      .fetch({
        method: this.isEditing ? 'put' : 'post',
        url: this.isEditing ? `/attachment-repositories/${id}` : '/attachment-repositories',
        apiVersion: 'v3',
        body: formData,
      })
      .then(() => {
        if (this.fetch.data) {
          NotificationService.addNotification(
            `Category ${this.isEditing ? 'updated' : 'created'} successfully.`,
            'success'
          );
          this.handleToggleCategoryModal();
          FileRepositoryTreeService.load();
        }
      });
  });
}

const fileRepositoryListService = new FileRepositoryCategoryService();

export default fileRepositoryListService;
